// src/pages/Terms.tsx
import React from "react";
import Header from "components/Header";
import Footer from "components/Footer";

export default function Terms() {
  const Wrap: React.CSSProperties = {
    maxWidth: 720,
    margin: "0 auto",
    padding: "16px 14px 40px",
    lineHeight: 1.9,
    color: "#0b1a27",
    background: "#fff",
  };
  const H1: React.CSSProperties = {
    fontSize: 22,
    fontWeight: 800,
    letterSpacing: "0.02em",
    margin: "22px 0 10px",
    color: "#1e73be",
  };
  const P: React.CSSProperties = { margin: "10px 0" };
  const UL: React.CSSProperties = { paddingLeft: 24, margin: "8px 0" };

  return (
    // 下付きフッター & body overflow対策
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#f5f7fb",
        overflowY: "auto",
      }}
    >
      <Header />

      <main style={{ flex: 1 }}>
        <div style={Wrap}>
          <h1 style={H1}>利用規約</h1>
          <p style={P}>
            本規約は、「BOAT億MAN」（以下「当サイト」といいます）が提供する全てのサービス（以下「本サービス」といいます）を利用する全ての方（以下「ユーザー」といいます）に適用されるものとします。ユーザーは、本規約に同意した上で本サービスを利用するものとします。
          </p>

          <h1 style={H1}>第1条（適用）</h1>
          <p style={P}>
            本規約は、当サイトとユーザーとの間の本サービスの利用に関わる一切の関係に適用されるものとします。当サイトは、本サービスに関し、本規約のほか、ご利用にあたってのルール等を定める場合があり、これらは本規約の一部を構成するものとします。
          </p>

          <h1 style={H1}>第2条（利用登録）</h1>
          <p style={P}>
            利用登録は、当サイト所定の方法により行うものとし、登録希望者が本規約に同意の上、登録を申請し、当サイトが承認した時点で完了するものとします。
          </p>

          <h1 style={H1}>第3条（禁止事項）</h1>
          <p style={P}>ユーザーは、本サービスの利用にあたり、以下の行為を行ってはなりません。</p>
          <ul style={UL}>
            <li>法令または公序良俗に違反する行為</li>
            <li>犯罪行為に関連する行為</li>
            <li>当サイトのサーバーやネットワーク機能を破壊・妨害する行為</li>
            <li>他のユーザーに関する個人情報等を不正に収集または蓄積する行為</li>
            <li>当サイトの運営を妨害する行為</li>
            <li>不正アクセスまたはこれを試みる行為</li>
            <li>当サイトのサービスに関して反社会的勢力に利益を供与する行為</li>
            <li>その他、当サイトが不適切と判断する行為</li>
          </ul>

          <h1 style={H1}>第4条（本サービスの提供の停止）</h1>
          <p style={P}>
            当サイトは、以下のいずれかに該当する場合、ユーザーへの事前通知なしに本サービスの全部または一部を停止または中断することができます。
          </p>
          <ul style={UL}>
            <li>システムの保守点検や更新を行う場合</li>
            <li>火災・停電・天災などの不可抗力によりサービス提供が困難な場合</li>
            <li>通信回線やサーバー等が事故により停止した場合</li>
            <li>その他、当サイトがサービス提供を困難と判断した場合</li>
          </ul>

          <h1 style={H1}>第5条（著作権）</h1>
          <p style={P}>
            当サイトに掲載される文章・画像・動画・プログラム等の著作物は、当サイトまたは正当な権利者に帰属します。無断での複製・転載・改変・配布等は禁止いたします。
          </p>

          <h1 style={H1}>第6条（免責事項）</h1>
          <ul style={UL}>
            <li>当サイトは、本サービスに関して、ユーザーに生じた損害について一切の責任を負いません。</li>
            <li>本サービスの利用に関連してユーザー間または第三者との間にトラブルが発生した場合でも、当サイトは一切関与せず、責任を負いません。</li>
          </ul>

          <h1 style={H1}>第7条（規約の変更）</h1>
          <p style={P}>
            当サイトは、必要と判断した場合、ユーザーへの予告なしに本規約を変更することができます。変更後の規約は、当サイト上に掲示された時点から効力を生じるものとします。
          </p>

          <h1 style={H1}>第8条（準拠法・管轄）</h1>
          <p style={P}>
            本規約の解釈および適用は日本法に準拠します。本サービスに関して生じた紛争については、当サイトの運営会社所在地を管轄する裁判所を専属的合意管轄とします。
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}
